import nClicks from '@web/libs/nlog/click/codes'

import ProfileBorderMissionCardContent from './ProfileBorderMissionCardContent'
import CompletedMissionCard from '../../MissionCard/CompletedMissionCard'
import { MissionCard, MissionCardProps } from '../../MissionCard/MissionCard'
import ProgressMissionCard from '../../MissionCard/ProgressMissionCard'

interface Props {
  missionCard: MissionCardProps
}

const ProfileBorderMissionCard = ({ missionCard }: Props) => {
  const Content = <ProfileBorderMissionCardContent missionCard={missionCard} />
  const Guide = missionCard.guide ? <>{missionCard.guide}</> : undefined

  if (MissionCard.isCompleteMission(missionCard)) {
    return (
      <CompletedMissionCard
        type="profile_border"
        missionCard={missionCard}
        foldable
        Content={Content}
        nClickArea={{
          openMore: nClicks.mission.DONECARD8,
          closeMore: nClicks.mission.DONEXCARD8,
        }}
      />
    )
  }

  return (
    <ProgressMissionCard
      type="profile_border"
      missionCard={missionCard}
      Guide={Guide}
      Content={Content}
      nClickArea={{
        openGuide: nClicks.mission.TIPCARD8,
        closeGuide: nClicks.mission.TIPXCARD8,
      }}
    />
  )
}

export default ProfileBorderMissionCard
